import gql from 'graphql-tag';

export const CREATE_DEAL_BUILDER_QUOTE_PROPOSAL = gql`
  mutation CreateDealBuilderQuoteProposal($proposalId: ID!, $input: CreateQuoteProposalInput!) {
    dealBuilder {
      createDealBuilderQuoteProposal(proposalId: $proposalId, input: $input) {
        success
        error
        entity {
          id
        }
      }
    }
  }
`;
